import BoardDeleteForm from "../components/BoardDeleteForm";

const BoardDeletePage = () => {
  return (
      <BoardDeleteForm />
  );
};

export default BoardDeletePage;
